<template>
    <div class="card multiple-file-uploader">
        <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
            <h3>Drop files to upload</h3>
        </div>
        <div class="upload">
            <div class="">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Miniatyr</th>
                            <th>Namn</th>
                            <th>Upplösning</th>
                            <th>Storlek</th>
                            <th>Hastighet</th>
                            <th>Status</th>
                            <th>Handling</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="!files.length">
                            <td colspan="9">
                                <div class="text-center p-5">
                                    <h4>Dra och släpp filer här<br/>eller</h4>
                                    <label for="file" class="btn btn-lg btn-primary"><i class="icon-plus3 mr-2"></i>Lägg till filer</label>
                                </div>
                            </td>
                        </tr>
                        <tr v-for="(file, index) in files" :key="file.id">
                            <td>{{index}}</td>
                            <td>
                                <img class="td-image-thumb" v-if="file.thumb" :src="file.thumb" />
                                <span v-else>Ingen bild</span>
                            </td>
                            <td>
                                <div class="filename">
                                    {{file.name}}
                                </div>
                                <div class="progress" v-if="file.active || file.progress !== '0.00'">
                                    <div :class="{'progress-bar': true, 'progress-bar-striped': true, 'bg-danger': file.error, 'progress-bar-animated': file.active}" role="progressbar" :style="{width: file.progress + '%'}">{{file.progress}}%</div>
                                </div>
                            </td>
                            <td>{{file.width || 0}}x{{file.height || 0}}</td>
                            <td>{{formatSize(file.size)}}</td>
                            <td>{{formatSize(file.speed)}}</td>
                            <td>
                                <div v-if="file.error"><div class="badge badge-danger">Error</div><div>{{file.error}}</div></div>
                                <div v-else-if="file.success" class="badge badge-success">Uppladdad</div>
                                <div v-else-if="file.active" class="badge badge-warning">Laddar upp...</div>
                            </td>
                            <td>
                                <div class="btn-group">
                                    <button class="btn btn-secondary btn-sm dropdown-toggle" type="button">
                                        Action
                                    </button>
                                    <div class="dropdown-menu">
                                        <a :class="{'dropdown-item': true, disabled: !file.active}" href="#"
                                           @click.prevent="file.active ? $refs.upload.update(file, {error: 'cancel', active: false}) : false">Avbryt</a>
                                        <a v-if="file.error && file.error !== 'compressing' && file.error !== 'image parsing' && $refs.upload.features.html5"
                                           class="dropdown-item" href="#" @click.prevent="$refs.upload.update(file, {active: true, error: '', progress: '0.00'})">Försök igen</a>
                                        <a v-else :class="{'dropdown-item': true, disabled: file.success || file.error === 'compressing' || file.error === 'image parsing'}" href="#"
                                           @click.prevent="file.success || file.error === 'compressing' || file.error === 'image parsing' ? false : $refs.upload.update(file, {active: true})">Ladda upp</a>
                                        <div class="dropdown-divider"></div>
                                        <a class="dropdown-item" href="#" @click.prevent="$refs.upload.remove(file)">Ta bort</a>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="card-footer">
                <file-upload
                    class="btn btn-primary"
                    :post-action="url"
                    :extensions="extensions"
                    :accept="accept"
                    :size="1024 * 1024 * 100"
                    :chunk-enabled="true"
                    :chunk="{
                        action: url,
                        minSize: 0,
                        maxActive: 1,
                        maxRetries: 1,
                        startBody: meta,
                        headers: headers,
                    }"
                    :headers="headers"
                    :data="meta"
                    :drop="true"
                    v-model="files"
                    @input-filter="inputFilter"
                    @input-file="inputFile"
                    ref="upload"
                    :maximum="maximum"
                    :multiple="multiple"
                >
                    <i class="icon-plus3 mr-2"></i>Lägg till filer
                </file-upload>
                <button type="button" class="btn btn-success" v-if="!$refs.upload || !$refs.upload.active" @click.prevent="startUpload" :disabled="disabled">
                    <i class="fa fa-arrow-up" aria-hidden="true"></i>
                    Starta uppladdning
                </button>
                <button type="button" class="btn btn-danger"  v-else @click.prevent="stopUpload">
                    <i class="fa fa-stop" aria-hidden="true"></i>
                    Stoppa uppladdning
                </button>
                <div v-if="message" class="text-danger d-inline-block">{{ message }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import FileUpload from 'vue-upload-component';
import { debounce } from 'lodash';

export default {
    components: {
        FileUpload,
    },
    props: {
        url: {
            type: String,
            required: true,
        },
        extensions: {
            type: String,
            default: '',
        },
        accept: {
            type: String,
            default: '',
        },
        meta: {
            type: Object,
            default() {
                return {};
            },
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        maximum: {
            type: Number,
            default() {
                return this.multiple ? 0 : 1;
            },
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        message: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            files: [],
            headers: {
                'X-CSRF-TOKEN': 'xxxx',
            },
            uploadAuto: false,
        };
    },
    watch: {
        files: {
            deep: true,
            handler() {
                this.updateBusy();
            },
        },
    },
    created() {
        const token = document.head.querySelector('meta[name="csrf-token"]');
        if (token) {
            this.headers['X-CSRF-TOKEN'] = token.content;
        }
    },
    methods: {
        // eslint-disable-next-line consistent-return
        inputFilter(newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // Before adding a file

                // Filter system files or hide files
                if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
                    return prevent();
                }

                // Filter php html js file
                if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
                    return prevent();
                }
            }

            if (newFile && newFile.error === '' && newFile.file && (!oldFile || newFile.file !== oldFile.file)) {
                // Create a blob field
                // eslint-disable-next-line no-param-reassign
                newFile.blob = '';
                const URL = (window.URL || window.webkitURL);
                if (URL) {
                    // eslint-disable-next-line no-param-reassign
                    newFile.blob = URL.createObjectURL(newFile.file);
                }

                // Thumbnails
                // eslint-disable-next-line no-param-reassign
                newFile.thumb = '';
                if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
                    // eslint-disable-next-line no-param-reassign
                    newFile.thumb = newFile.blob;
                }
            }

            // image size
            if (newFile && newFile.error === '' && newFile.type.substr(0, 6) === 'image/' && newFile.blob && (!oldFile || newFile.blob !== oldFile.blob)) {
                // eslint-disable-next-line no-param-reassign
                newFile.error = 'image parsing';
                const img = new Image();
                img.onload = () => {
                    this.$refs.upload.update(newFile, { error: '', height: img.height, width: img.width });
                    this.$refs.upload.update(newFile, { data: { ...newFile.data, height: img.height, width: img.width } });
                };
                img.οnerrοr = () => {
                    this.$refs.upload.update(newFile, { error: 'parsing image size' });
                };
                img.src = newFile.blob;
            }
        },

        // add, update, remove File Event
        inputFile(newFile, oldFile) {
            if (newFile && oldFile) {
                // update

                if (newFile.active && !oldFile.active) {
                    // beforeSend

                    // min size
                    if (newFile.size >= 0 && this.minSize > 0 && newFile.size < this.minSize) {
                        this.$refs.upload.update(newFile, { error: 'size' });
                    }
                }

                if (newFile.progress !== oldFile.progress) {
                    // progress
                }

                if (newFile.error && !oldFile.error) {
                    // error
                }

                if (newFile.success && !oldFile.success) {
                    // success
                }
            }

            if (!newFile && oldFile) {
                // remove
                if (oldFile.success && oldFile.response.id) {
                    // $.ajax({
                    //   type: 'DELETE',
                    //   url: '/upload/delete?id=' + oldFile.response.id,
                    // })
                }
            }

            // Automatically activate upload
            if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
                if (this.uploadAuto && !this.$refs.upload.active) {
                    this.$refs.upload.active = true;
                }
            }
        },
        formatSize(size) {
            if (size > 1024 * 1024 * 1024 * 1024) {
                return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB';
            }
            if (size > 1024 * 1024 * 1024) {
                return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB';
            }
            if (size > 1024 * 1024) {
                return (size / 1024 / 1024).toFixed(2) + ' MB';
            }
            if (size > 1024) {
                return (size / 1024).toFixed(2) + ' KB';
            }
            return size.toString() + ' B';
        },
        startUpload() {
            this.$emit('busy', true);
            this.$refs.upload.active = true;
        },
        stopUpload() {
            this.$refs.upload.active = false;
            this.$emit('busy', false);
        },
        updateBusy: debounce(function debouncedUpdateBusy() {
            const vm = this;
            let busy = false;
            vm.files.forEach((file) => {
                if (file.active) {
                    busy = true;
                }
            });
            this.$emit('busy', busy);
        }, 500),
    },
};
</script>

<style>
.multiple-file-uploader .btn-group .dropdown-menu {
    display: block;
    visibility: hidden;
    transition: all .2s
}

.multiple-file-uploader .btn-group:hover > .dropdown-menu {
    visibility: visible;
}

.multiple-file-uploader .btn-group .dropdown-toggle {
    margin-right: .6rem
}

.multiple-file-uploader .td-image-thumb {
    max-width: 4em;
    max-height: 4em;
}

.multiple-file-uploader .filename {
    margin-bottom: .3rem
}

.multiple-file-uploader .drop-active {
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    position: fixed;
    z-index: 9999;
    opacity: .6;
    text-align: center;
    background: #000;
}

.multiple-file-uploader .drop-active h3 {
    margin: -.5em 0 0;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    font-size: 40px;
    color: #fff;
    padding: 0;
}

.multiple-file-uploader .file-uploads label {
    cursor: pointer;
}
</style>
